import { useEffect, useState } from "react";
import InputText from "../ReusableComponents/InputText";
import { mainTable } from "../css/Common";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import TextArea from "../ReusableComponents/TextArea";
const DamagesMainPopup = ({ data, data1 }) => {
  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    if (data1.length > 0) {
      setTableData(data1);
    }
  }, [data1]);
  if (!data || !data1) return null;

  return (
    <div className="w-full">
      <form className="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit sm:max-h-fit">
        <div className={mainTable.grid5}>
          <InputText
            title="Damages No"
            name="Damages No"
            classStar="text-red-500"
            content={data.DamageNo}
            disabled={true}
          />
          <InputText
            title="Date"
            name="Date"
            classStar="text-red-500"
            content={data.Date}
            disabled={true}
          />
          <InputText
            title="Room Type"
            name="RoomType"
            classStar="text-red-500"
            content={data.RoomTypeName}
            disabled={true}
          />
          <InputText
            title="Room"
            name="Room"
            classStar="text-red-500"
            content={data.RoomName}
            disabled={true}
          />
          <InputText
            title="Reported By"
            name="ReportedBy"
            classStar="text-red-500"
            content={data.StaffName}
            disabled={true}
          />
        </div>
        <div className="w-full max-h-[400px] overflow-auto mt-6">
          <table className="w-full border border-gray-300">
            <thead className="bg-[#3D6643] text-white sticky top-0 z-10">
              <tr>
                <th className="border px-2 py-2 w-[30px]">SN</th>
                <th className="border px-4 py-2 w-[200px]">Item Type</th>
                <th className="border px-4 py-2 w-[200px]">Category</th>
                <th className="border px-4 py-2 w-[230px]">Name</th>
                <th className="border px-4 py-2 w-[100px]">U.O.M</th>
                <th className="border px-4 py-2 w-[90px]">Quantity</th>
                <th className="border px-4 py-2 w-[100px]">Value</th>
              </tr>
            </thead>
            <tbody>
              {tableData?.map((row, index) => (
                <tr key={index}>
                  <td className="border px-1 py-2 text-center">{index + 1}</td>

                  <td className="border px-2 py-2">
                    <AutoDropDown
                      name="itemtype"
                      Class="custom-class"
                      disabled={true}
                      options={[]}
                      selectedOption={{
                        value: row.MstItemTypeId,
                        label: row.ItemType,
                      }}
                      placeholder="Select"
                    />
                  </td>

                  <td className="border px-2 py-2">
                    <AutoDropDown
                      name="itemcategory"
                      Class="custom-class"
                      disabled={true}
                      options={row.itemCategoryList || []}
                      selectedOption={{
                        value: row.MstItemcategoryId,
                        label: row.ItemCategory,
                      }}
                      placeholder="Select"
                    />
                  </td>

                  <td className="border px-2 py-2">
                    <AutoDropDown
                      name="itemname"
                      Class="custom-class"
                      disabled={true}
                      options={row.itemList || []}
                      selectedOption={{
                        value: row.MstItemId,
                        label: row.ItemName,
                      }}
                      placeholder="Select"
                    />
                  </td>

                  <td className="border px-2 py-2">
                    <InputText
                      inputType="text"
                      name="uom"
                      content={row.MstUOMId}
                      disabled={true}
                    />
                  </td>

                  <td className="border px-2 py-2">
                    <InputText
                      inputType="number"
                      name="quantity"
                      content={row.Quantity}
                      disabled={true}
                    />
                  </td>
                  <td className="border px-4 py-2">
                    <InputText
                      name="value"
                      content={row.Value}
                      disabled={true}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="mt-4">
          <TextArea
            title="Remarks"
            name="remarks"
            content={data?.Remarks || ""}
            rows={4}
            disabled={true}
            maxlength={500}
          />
        </div>
      </form>
    </div>
  );
};

export default DamagesMainPopup;
